import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteIssuesStatusesListError, deleteIssuesStatusesListSuccess,

    getIssuesStatusesListError,
    getIssuesStatusesListSuccess
} from './actions';
import {
    ISSUES_STATUSES_DELETE_ITEMS, ISSUES_STATUSES_GET_LIST, ISSUES_STATUSES_INITIALIZE_LIST
} from './actions_def';


const apiUrl = servicePath;

const initializeIssuesStatusesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/statuses/initialize',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* initializeIssuesStatusesList({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getIssuesStatusesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(initializeIssuesStatusesListRequest, payload);
            yield put(getIssuesStatusesListSuccess(response));
        } catch (error) {
            yield put(getIssuesStatusesListError(error));
        }
    }
}

const getIssuesStatusesListRequest = async (payload) => {
    // console.log(payload);
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload.projectId + '/statuses/',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => item)
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getIssuesStatusesList({ payload }) {
    // // console.log(payload);;

    if (!payload) {
        yield put(getIssuesStatusesListError({ error: 'prerequisites' }));
    }
    else {
        try {
            const response = yield call(getIssuesStatusesListRequest, payload);
            yield put(getIssuesStatusesListSuccess(response));
        } catch (error) {
            yield put(getIssuesStatusesListError(error));
        }
    }
}


const deleteIssuesStatusesListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (items.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/statuses/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.status === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.status === "success" || response.data.status === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.status)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesStatusesList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteIssuesStatusesListRequest, payload);
        yield put(deleteIssuesStatusesListSuccess(response));
    } catch (error) {
        yield put(deleteIssuesStatusesListError(error));
    }
}



export function* watchGetList() {
    yield takeEvery(ISSUES_STATUSES_GET_LIST, getIssuesStatusesList);
}

export function* watchInitializeList() {
    yield takeEvery(ISSUES_STATUSES_INITIALIZE_LIST, initializeIssuesStatusesList);
}

export function* watchDeleteItems() {
    yield takeEvery(ISSUES_STATUSES_DELETE_ITEMS, deleteIssuesStatusesList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetList),
        fork(watchInitializeList),
        fork(watchDeleteItems),
    ]);
}
